<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconList"
})
</script>

<template>
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
